import HorizontalBreak from '@src/navigation/vertical/HorizontalBreak';

const VerticalNavMenuSectionDivider = ({ item }: any) => {
  return (
    <li className="navigation-divider">
      <HorizontalBreak color="light-grey" key={`${item.id}-horizontalBreak`} />
    </li>
  );
};

export default VerticalNavMenuSectionDivider;
